"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPLACE_ME = exports.UNKNOWN = void 0;
exports.UNKNOWN = 'UNKNOWN';
exports.REPLACE_ME = 'REPLACE ME';
//# sourceMappingURL=constances.js.map